export default __webpack_public_path__ + "static/media/bg.596896b8.png";